import ApiMixin from "../ApiMixin";

export default {
    mixins: [
        ApiMixin,
    ],
    props: {
        source: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            claim_method: '',
        }
    },
    methods: {
        
    },
};